import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { Navbar } from "@/components/Navbar";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Market from "@/pages/Market";
import SellerPanel from "@/pages/SellerPanel";
import AdvancedModules from "@/pages/AdvancedModules";
import { Loader2 } from "lucide-react";

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-[#05050A]">
      <Navbar />
      <main className="max-w-7xl mx-auto px-6 py-8">{children}</main>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#05050A]">
        <Loader2 className="w-8 h-8 text-primary animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Shell>{children}</Shell>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<PublicOnly><Auth /></PublicOnly>} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/market" element={<Protected><Market /></Protected>} />
              <Route path="/seller" element={<Protected><SellerPanel /></Protected>} />
              <Route path="/modules" element={<Protected><AdvancedModules /></Protected>} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
